// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"h_h","wrapperDark":"h_n","navbar":"h_p","brandwrap":"h_q","brandtop":"h_r","brandbottom":"h_s","logoLink":"h_t","logo":"h_v","navigation":"h_w"};